export default "__VITE_ASSET__BuNBjG24__"